export default "__VITE_ASSET__BuVk_OM7__"